import { FC } from "react";

const Footer: FC = () => {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <footer className="footer" style={{ padding: "10px 30px" }}>
      <span className="hidden-md-down fw-700">{year} © Bayi İŞNET</span>
    </footer>
  );
};

export default Footer;
